const icon = state => state.icon;
const client = state => state.client;
const clientContacts = state => state.clientContacts;
const site = state => state.site;
const sites = state => state.sites;
const building = state => state.building;
const buildings = state => state.buildings;
const plant = state => state.plant;
const plants = state => state.plants;

export default {
  icon,
  client,
  clientContacts,
  sites,
  site,
  buildings,
  building,
  plants,
  plant
};
